export interface BehaviorDefinition {
  id: number;
  name: string;
  definition: string;
  examples: string[];
  nonExamples: string[];
}

export const behaviorDefinition: BehaviorDefinition[] = [
  {
    id: 1,
    name: 'Self Injury',
    definition:
      'Engages in physical act toward oneself that may cause damage to ones on body.',
    examples: [
      'Head-banging',
      'Biting',
      'Hand rubbing or scratching of skin',
      'Poking eyes',
    ],
    nonExamples: [
      'Soft scratching or rubbing an area of the body to relieve irritation or pain',
    ],
  },
  {
    id: 2,
    name: 'Aggression',
    definition:
      'Making forceful physical contact with others with hands or feet, as well as throwing items not intended for throwing with enough force to make an audible sound or leave visible marks on others. Also includes verbally interacting with others in a manner that is derogatory, intimidating, threatening or vulgar.',
    examples: [
      'Kicking',
      'Throwing things',
      'Biting',
      'Choking',
      'Grabbing',
      'Hitting',
      'Pinching',
      'Pulling hair',
      'Pushing',
      'Spitting at or on others',
      'Swearing/cussing at someone',
      'Threatening physical attack toward others',
      'Yelling at others',
      'Name calling',
    ],
    nonExamples: [
      'Kicking a ball with someone in play',
      'Giving someone a hug',
      'High five',
      'Running into someone accidentally',
      'Interrupting',
      'Talking back',
      'Talking loudly',
      'Telling inappropriate jokes',
    ],
  },
  {
    id: 3,
    name: 'Tantrum',
    definition:
      'Engaging in dysregulated behaviors that involves loss of emotional control demonstrated by',
    examples: [
      'Flops to the ground',
      'Flails arms/legs',
      'Crying',
      'Screaming',
      'Whines',
      'Running away',
    ],
    nonExamples: [
      'Putting head down on desk',
      'Walking away to a different area in the room',
      'Refusal to comply',
      'Mumbling',
    ],
  },
  {
    id: 4,
    name: 'Classroom Disruption',
    definition:
      'Engaging in any behavior that deviates from the teacher directions that may cause others to become distracted or off task.',
    examples: [
      'Out of seat without permission',
      'Making noises',
      'Destroys things in the classroom',
      'Interrupts teacher instruction to argue',
      'Slam doors',
    ],
    nonExamples: [
      'Out of seat with permission',
      'Head down on desk',
      'Talking to peers about the assignment',
      'Use of electronic device with permission (e.g., as a reward, etc.)',
    ],
  },
  {
    id: 5,
    name: 'Property Destruction',
    definition: 'Engaging in behaviors that causes damage to property.',
    examples: [
      'Hitting or throwing one object (such as desk, chairs, computer, or other classroom materials) against another with enough force to break or disfigure the object',
    ],
    nonExamples: [
      'Using classroom furniture and materials as designed',
      'Sitting in chair/desk',
      'Reading materials',
      'Tapping softly on keypad',
    ],
  },
  {
    id: 6,
    name: 'Off-Task',
    definition:
      'Engaging in behaviors that deviates from a specific task/assignment.',
    examples: [
      'Out of seat without permission',
      'Making noises',
      'Talking to peers without permission',
      'Use of electronic devices without permission',
      'Staring out the window',
      'Head down on desk',
      'Refusing to complete task',
    ],
    nonExamples: [
      'Out of seat with permission',
      'Sitting quietly during task transitions',
      'Talking to peers about the assignment',
      'Use of electronic device with permission (e.g., as a reward, etc.)',
      'Working quietly while completing task',
    ],
  },
  {
    id: 7,
    name: 'Socially inappropriate comments, statements, etc.',
    definition:
      'Making verbal statements that are inappropriate or do not relate to a specific conversation.',
    examples: [
      'Speaking about inappropriate topics',
      'Insults others',
      'Swearing',
      'Uses vulgar language',
      'Making inappropriate jokes',
      'Repetitive vocalization',
    ],
    nonExamples: [
      'Threats',
      'Intimidation',
      'Properly greeting others',
      'Issuing a complement',
    ],
  },
  {
    id: 8,
    name: 'Other unsafe or disruptive behavior',
    definition:
      'Behaviors that may cause harm or disruption but do not fit into other specific categories. Includes repetitive body movements, inappropriate mouthing behaviors, and motor stereotypies.',
    examples: [
      'Rocking or swaying torso from side to side or back and forth',
      'Chewing a pen, eraser, clothing, toy, hair',
      'Finger wiggling',
      'Hand-flapping',
      'Opening and closing fist',
      'Head nodding',
    ],
    nonExamples: [
      'Body movements while listening to music',
      'Body movements associated with exercising',
      'Movement due to muscle spasm',
      'Placing food items in mouth',
      'Licking food off an eating utensil or container',
      'Clapping hands or tapping foot to music',
      'Motor imitation task',
    ],
  },
  {
    id: 9,
    name: 'Elopement',
    definition:
      "Walking or running away from the designated area more than an arm's length away without adult permission and ignoring directives to come back.",
    examples: [
      'Leaving the classroom without permission',
      'Running away from staff',
      'Leaving the school grounds',
      'Roaming the hallway during class time',
    ],
    nonExamples: [
      'In hallway with pass',
      'Leaving assigned area with staff permission',
      'Going to the bathroom in case of an emergency',
    ],
  },
  {
    id: 10,
    name: 'Bus',
    definition: 'Engaging in behavior deemed unsafe or unruly on the bus.',
    examples: [
      'Out of seat while bus is moving',
      'Distracting driver',
      'Placing body parts outside the window',
      'Property destruction',
      'Aggression toward others',
    ],
    nonExamples: [
      'Talking to others while sitting',
      'In seat while bus is moving',
      'Hands in lap or on the seat',
    ],
  },
];
